export const infoProyectInit = {
	link: "",
	proyectInfo: {},
	clientInfo: {},
	teamUser: [],
	dates: {
		start: "",
		end: "",
	},
};

export const indicatorTableProject = {
	infoIndicator: [],
	hoursProject: {
		hours_clickup_total: 0,
		hours_extras_total: 0,
		hours_extra_not_aprobate: 0,
		hours_resource_extra: 0,
		hours_total_project: 0,
		hours_budget: 0,
		hours_time_left: 0,
		consume: 0,
	},
};

export const selectFormExtraResource = {
	doesHaveImpact: false,
	area: "",
	extraresources: "",
	typeextraresources: "",
	amount: 0,
	currency: "USD",
	hours: 0,
	comment: "",
	dateStart: "",
	dateFinished: "",
	extraresourcesData: false,
};

export const typeForm = {
	create: 0,
	edit: 1,
};

export const sizeNomenclatureProject = {
	XS: { name: "XS", id: 0 },
	S: { name: "S", id: 1 },
	M: { name: "M", id: 2 },
	L: { name: "L", id: 3 },
	XL: { name: "XL", id: 4 },
	XXL: { name: "XXL", id: 5 },
	E: { name: "E", id: 6 },
	F: { name: "F", id: 7 },
};
